import React from 'react';
import {twMerge} from 'tailwind-merge';

type Props = {
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
};

const PageContent = ({children, style, className}: Props) => {
  return (
    <div
      style={style}
      className={twMerge('w-full max-w-[800px] px-6 self-center grow flex flex-col shrink-0 mb-12', className)}
    >
      {children}
    </div>
  );
};

export default PageContent;
